export class ChangeDeform {
    constructor() {
    }
    apply(frame, vb, slots) {
        if (frame >= this.startFrame) {
            if (this._lastFrame >= this.endFrame && frame >= this.endFrame)
                return false;
            this._lastFrame = frame;
            return this.updateVB(vb, slots);
            ;
        }
        else
            return false;
    }
    initChange(vb) {
        this.sizeMap = vb.slotVBMap.get(this.slotId);
        return true;
    }
    updateVB(vb, slots) {
        if (!this.sizeMap) {
            this.sizeMap = vb.slotVBMap.get(this.slotId);
            if (!this.sizeMap) {
                return false;
            }
        }
        let slot = slots[this.slotId];
        if (slot.attachment) {
            let deform = slot.deform;
            if (!deform || !deform.length) {
                return false;
            }
            let vertexSize = vb.vertexSize;
            let attachmentPos = this.sizeMap.get(slot.attachment.name);
            let offset = attachmentPos.offset * vertexSize;
            let vbData = vb.vb;
            let attachmentParse = attachmentPos.attachment;
            vb.appendDeform(attachmentParse, deform, offset, vbData);
        }
        return true;
    }
    clone() {
        let out = new ChangeDeform;
        out.slotId = this.slotId;
        out.startFrame = this.startFrame;
        out.endFrame = this.endFrame;
        return out;
    }
}
